// extracted by mini-css-extract-plugin
export default {"offer":"Offer_offer__+Mplj","offerCart":"Offer_offerCart__XpnLc"};